import './card-list.scss';

import React from 'react';
import { z } from 'zod';

import { cn } from '@sola/ark-core/utils/helpers.ts';

export const CardListProps = z.object({
  columns: z.enum(['1', '2']).pipe(z.coerce.number()).optional(),
  columnsSm: z.enum(['1', '2']).pipe(z.coerce.number()).optional(),
  columnsMd: z.enum(['1', '2', '3']).pipe(z.coerce.number()).optional(),
  columnsLg: z.enum(['1', '2', '3', '4']).pipe(z.coerce.number()).optional(),
  classNameGap: z.string().optional(),
});

export type CardListProps = z.infer<typeof CardListProps>;

export const CardList: React.FC<
  CardListProps & {
    children: React.ReactElement | React.ReactElement[];
  }
> = ({
  columns = 1,
  columnsSm = 1,
  columnsMd = 3,
  columnsLg = 3,
  classNameGap,
  children,
}) => {
  const childrenArray = React.Children.toArray(children);

  return (
    <div className="CardList" data-length={childrenArray.length}>
      <div
        className={cn(`CardList__container gap-comfy-sm`, classNameGap, {
          [`CardList--${columns}`]: columns,
          [`CardList--sm-${columnsSm}`]: columnsSm,
          [`CardList--md-${columnsMd}`]: columnsMd,
          [`CardList--lg-${columnsLg}`]: columnsLg,
          'md:gap-comfy-lg':
            !classNameGap &&
            childrenArray.length >= 3 &&
            childrenArray.length < 5,
          'lg:gap-comfy-xl': !classNameGap && childrenArray.length < 3,
        })}
      >
        {children}
      </div>
    </div>
  );
};
